const dailyTextsData = [
  {
    text: "רבי זירא כי סליק לארעא דישראל יתיב מאה תעניתא דלשתכח גמרא בבלאה מיניה, כי היכי דלא נטרדיה.",
    source: "בבא מציעא דף פה עמוד א",
  },
  {
    text: "שמע מינה: אוירא דארץ ישראל מחכים.",
    source: "בבא בתרא דף קנח עמוד ב",
  },
  {
    text: "וכל חד מינן כי סליק להתם עדיף כתרי מינייהו.",
    source: "בבא בתרא דף קנח עמוד ב",
  },
  {
    text: "נראה לי הטעם כי בני ארץ ישראל טבע הארץ מסייע להם משום דאוירא דארץ ישראל מחכים.",
    source: 'ריב"ש, כתובות',
  },
  {
    text: "יש לך לדעת כי אלו שתי מדות לפי מדת ארץ ישראל ומדת בבל. וזה כי ארץ ישראל הקדושה, התורה שבה אינה יוצאה מן הסדר ומן השווי כמו שהאדם הוא בעצמו כמו שהתבאר, כי הארץ הזאת הקדושה היא באמצע העולם יורה שכל הדברים שבה הם בשווי ובסדר הראוי.",
    source: 'מהר"ל, נתיב התורה פרק יג',
  },
  {
    text: "הדמיון של ארץ ישראל הוא צלול וברור, נקי וטהור ומסוגל להופעת האמת האלהית להלבשת החפץ המרומם והנשגב של המגמה האידיאלית אשר בעליונות הקדש, מוכן להסברת נבואה ואורותיה, להבהקת רוח הקדש וזהריו.",
    source: 'הראי"ה קוק, קובץ ז פסקה קסז',
  },
  {
    text: 'אי אפשר לאדם מישראל שיהיה מסור ונאמן למחשבותיו הגיונותיו, רעיונותיו ודמיונותיו, בחוץ לארץ, כתכונת הנאמנות הזאת בארץ ישראל. הופעות הקדש, באיזו מדרגה שהן, נקיות הן בארץ ישראל לפי הערך, ובחוץ לארץ מעורבות הן בסיגים וקלפות מרובים. אמנם לפי גודל התשוקה והקשור של האדם לארץ ישראל, הרי רעיונותיו מזדככים מיסוד אוירא דארץ ישראל החופף על כל מי שמצפה לראותה. "שמחו את ירושלים וגילו בה כל אוהביה".',
    source: 'הראי"ה קוק, קובץ ו פסקה קעז',
  },
];
export default dailyTextsData;
